import './style/entryData.scss';

import {
    capitalize, ChangeFunction, ChangeKeyFunction, Checkbox, CloseButton, DvrdButton, DvrdInput, preventDefault,
    WithBackground
} from '@dvrd/dvr-controls';
import React, {MouseEventHandler, useMemo} from 'react';
import {WaitlistDay} from '../../../enums';
import WaitlistEntry, {WaitlistEntryFields} from '../../../models/waitlistEntryModel';

interface Props {
    onClose: MouseEventHandler;
    onChange: ChangeKeyFunction<keyof WaitlistEntryFields, any>;
    onSelectDay: (day: WaitlistDay) => ChangeFunction<boolean>;
    onSubmit: MouseEventHandler;
    entry: WaitlistEntry;
    active: boolean;
    loading: boolean;
}

export default function EntryData(props: Props) {
    const {onClose, onChange, onSelectDay, onSubmit, entry, active, loading} = props;
    const action = useMemo(() => {
        if (!entry.id) return 'toevoegen';
        return 'bijwerken';
    }, [entry.id]);

    function renderBody() {
        return (
            <form onSubmit={preventDefault} className='body-container'>
                <div className='days-container'>
                    <label className='days-container-label'>Dagen</label>
                    {renderDay(WaitlistDay.MONDAY)}
                    {renderDay(WaitlistDay.TUESDAY)}
                    {renderDay(WaitlistDay.WEDNESDAY)}
                    {renderDay(WaitlistDay.THURSDAY)}
                    {renderDay(WaitlistDay.FRIDAY)}
                    {renderDay(WaitlistDay.MISC)}
                </div>
                <div className='names'>
                    <DvrdInput value={entry.customerName ?? ''} onChange={onChange('customer_name')} label='Klantnaam'
                               placeholder='Klantnaam'/>
                    <DvrdInput value={entry.dogName ?? ''} onChange={onChange('dog_name')} label='Naam hond'
                               placeholder='Djuna'/>
                </div>
                <DvrdInput value={entry.tel ?? ''} onChange={onChange('tel')} label='Telefoonnummer'
                           placeholder='Telefoonnummer' type='tel'/>
                <DvrdInput value={entry.email ?? ''} onChange={onChange('email')} label='E-mailadres'
                           placeholder='E-mailadres' type='email'/>
                <DvrdInput value={entry.comment ?? ''} onChange={onChange('comment')} label='Notities'
                           placeholder='Notities' inputProps={{rows: 5}} area/>
            </form>
        );
    }

    function renderDay(day: WaitlistDay) {
        const label = {
            [WaitlistDay.MONDAY]: 'Maandag',
            [WaitlistDay.TUESDAY]: 'Dinsdag',
            [WaitlistDay.WEDNESDAY]: 'Woensdag',
            [WaitlistDay.THURSDAY]: 'Donderdag',
            [WaitlistDay.FRIDAY]: 'Vrijdag',
            [WaitlistDay.MISC]: 'Overig'
        }[day];
        return <Checkbox checked={entry.days.includes(day)} onCheck={onSelectDay(day)} label={label}/>;
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='default-popup entry-data'>
                <div className='header-container'>
                    <label className='header-label'>Klant {action}</label>
                    <CloseButton onClick={onClose}/>
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <DvrdButton onClick={onClose} label='Sluiten' disabled={loading} secondary/>
                    <DvrdButton onClick={onSubmit} label={capitalize(action)} disabled={loading}/>
                </div>
            </div>
        </WithBackground>
    );
}

EntryData.displayName = 'EntryData';